import { IsArray, IsEnum, IsMongoId, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from "class-validator";
import { Type } from "class-transformer";
import { Constants } from "@eagerdog/constants";

export class StoreItemDto {
  @IsMongoId()
  @IsNotEmpty()
  add_on_id: string;

  @IsNumber()
  @IsNotEmpty()
  quantity: number;
}

export class StorePurchaseDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => StoreItemDto)
  items: StoreItemDto[];

  @IsEnum(Object.values(Constants.payment_method_type))
  @IsNotEmpty()
  payment_method_type: string;

  @IsOptional()
  @IsString()
  payment_card_type?: string;

  @IsOptional()
  @IsString()
  payment_method_id?: string;

  @IsOptional()
  @IsString()
  customer_first_name?: string;

  @IsOptional()
  @IsString()
  customer_last_name?: string;

  @IsOptional()
  @IsString()
  customer_email?: string;

  @IsOptional()
  @IsString()
  customer_phone?: string;

  @IsOptional()
  @IsString()
  cheque_number?: string;
}

export class CompleteStorePurchaseDto extends StorePurchaseDto {
  @IsOptional()
  @IsString()
  payment_intent_id?: string;

  // Customer information now inherited from StorePurchaseDto but required here
  @IsNotEmpty()
  @IsString()
  customer_first_name: string;

  @IsNotEmpty()
  @IsString()
  customer_last_name: string;

  @IsNotEmpty()
  @IsString()
  customer_email: string;

  @IsOptional()
  @IsString()
  customer_phone?: string;
}

